/*
 * Module for viewing and changing the default content URL.
 */

define(["marionette", "messaging/messenger", "./defaultUrlView"], function (
  Marionette,
  Messenger,
  defaultUrlView,
) {
  var defaultUrlModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "DefaultUrl";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      //get the default content URL (probably not synced!)
      this.defaultUrlModel = Messenger.reqres.request("kb:default:content:url");
      this.defaultUrlModel.set("defaultUrl", _.unescape(this.defaultUrlModel.get("defaultUrl")));

      Messenger.onSave(function () {
        this.defaultUrlModel.set("defaultUrl", this.defaultUrlModel.get("defaultUrl"));
        this.defaultUrlModel.saveModel();
      }, this);

      this.view = new defaultUrlView.defaultUrlView({ model: this.defaultUrlModel });

      this.showRegion(this.view, { loading: false, entity: this.defaultUrlModel });
    },
    _setUpVents: function () {
      //show the module
      Messenger.vent.on(
        "show:kb:admin:defaultURL",
        function () {
          this.show();
        },
        this,
      );
      Messenger.vent.on(
        "show:kb:profile:defaultURL",
        function () {
          this.show();
        },
        this,
      );
    },
  });

  return defaultUrlModule;
});
